<template>
    <div>
      <common-dialog
        ref="dialog"
        width="900px"
        :show-save-button="$permission.canEdit()"
        unit="会员标签"
        edit-title
        id-key="RecordId"
      
        form-label-width="125px"
       
      >
        <template slot="form">
          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="标签名称" prop="">
                <el-input placeholder="请填写标签名称" clearable></el-input>
              </el-form-item>
            </el-col>
           
          </el-row>
         

         
          <el-row>
            <el-col :span="isMB?24:12" >
              <el-form-item label="序号" prop="">
                <el-input-number  :min="0" />
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12" >
              <el-form-item label="状态" prop="">
                 <el-radio-group v-model="data.State">
                  <el-radio :label="1">启用</el-radio>
                  <el-radio :label="0">停用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
         
        </template>
        <template #footer v-if="!$permission.canEdit()">
           <el-button @click="close">关 闭</el-button>
      </template>
      </common-dialog>
    </div>
  </template>
  <script>
  import editDialogMixin from "@/mixins/editDialog";
  import commonDialog from "@/components/common/dialog";
 
  
  export default {
    mixins: [editDialogMixin],
    components: {
      commonDialog,
    
    },
    data() {
      return {
       data: {
         
          State: 1,
        },
        isMB: this.$store.state.isMB,
        rules: {
         
        },
      };
    },
    methods: {
     
     
    },
  };
  </script>